module.exports = __webpack_public_path__ + "img/Support-skill-427.aa520855.png";